const FORM_SELECTOR =
    '[data-map-suggestion-form]';

function initializeTargetSelector(form) {
    if (
        form.dataset
            .mapSuggestionTargetReady
        === 'true'
    ) {
        return;
    }

    const typeSelect = form.querySelector(
        '[data-map-suggestion-type]'
    );

    const targetSelect = form.querySelector(
        '[data-map-suggestion-target]'
    );

    const help = form.querySelector(
        '[data-map-suggestion-target-help]'
    );

    if (
        !typeSelect
        || !targetSelect
    ) {
        return;
    }

    form.dataset
        .mapSuggestionTargetReady =
            'true';

    const updateTargetState = () => {
        const type = typeSelect.value;

        const requiredKind =
            type === 'landmark_correction'
                ? 'landmark'
                : type === 'zone_correction'
                    ? 'zone'
                    : type === 'junction_correction'
                        ? 'junction'
                        : type === 'path_correction'
                            ? 'path'
                            : null;

        Array.from(
            targetSelect.options
        ).forEach((option) => {
            const kind =
                option.dataset.targetKind
                || 'none';

            const shouldShow =
                requiredKind === null
                || kind === 'none'
                || kind === requiredKind;

            option.hidden = !shouldShow;
            option.disabled = !shouldShow;
        });

        targetSelect.required =
            requiredKind !== null;

        if (requiredKind === null) {
            targetSelect.value = '';

            if (help) {
                help.textContent =
                    'No existing map item is required for a new landmark, new zone, new junction / waypoint, or general suggestion.';
            }

            return;
        }

        const selectedOption =
            targetSelect
                .selectedOptions[0];

        const selectedKind =
            selectedOption
                ?.dataset.targetKind
                || 'none';

        if (
            selectedKind
            !== requiredKind
        ) {
            targetSelect.value = '';
        }

        if (help) {
            help.textContent =
                requiredKind === 'landmark'
                    ? 'Choose the existing landmark you want to correct.'
                    : requiredKind === 'zone'
                        ? 'Choose the existing zone you want to correct.'
                        : requiredKind === 'junction'
                            ? 'Choose the existing junction / waypoint you want to correct.'
                            : 'Choose the existing path / trail you want to correct.';
        }
    };

    typeSelect.addEventListener(
        'change',
        updateTargetState
    );

    updateTargetState();
}

function initializeTargetSelectors() {
    document
        .querySelectorAll(FORM_SELECTOR)
        .forEach(initializeTargetSelector);
}

if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeTargetSelectors,
        {
            once: true,
        }
    );
} else {
    initializeTargetSelectors();
}

document.addEventListener(
    'livewire:navigated',
    initializeTargetSelectors
);
